
import { BrowserRouter } from 'react-router-dom'
import './styles/App.scss'
import AppRouter from './routes/Router'
import { Provider } from 'react-redux'
import { store } from './store/store'
import { ToastContainer } from "react-toastify";
import { LanguageProvider } from './context/LanguageContext';
import "react-toastify/dist/ReactToastify.css";
import FullPageLoader from './common/FullPageLoader';
import UnderMaintenance from './maintenance/UnderMaintenance';
import useMaintenanceCheck from './hooks/useMaintenanceCheck';

function App() {
  const { isChecking, isUnderMaintenance, message } = useMaintenanceCheck();

  if (isChecking) {
    return <FullPageLoader show={true} />;
  }

  if (isUnderMaintenance) {
    return <UnderMaintenance message={message} />;
  }

  return (
    <LanguageProvider>
      <Provider store={store}>
        <BrowserRouter>
            <ToastContainer autoClose={5000} icon={false}/>
            <AppRouter/>
        </BrowserRouter>
      </Provider>
    </LanguageProvider>
    
  )
}

export default App
